import { analytics } from './analytics'
import { cache } from './cache'
import { cleaner } from './cleaner'
import { pluginConsole } from './console'
import { createFeatureFlagsPlugin } from './featureFlags'
import { httpAnalyzer } from './httpAnalyzer'
import { playground } from './playground'
import { requests } from './requests'
import { safeArea } from './safeArea'
import { translations } from './translations'

const plugin = {
  requests,
  cache,
  httpAnalyzer,
  analytics,
  console: pluginConsole,
  playground,
  cleaner,
  featureFlags: createFeatureFlagsPlugin,
  translations,
  safeArea,
}
const defaultPlugins = [
  plugin.requests,
  plugin.cache,
  plugin.httpAnalyzer,
  plugin.analytics,
  plugin.console,
  plugin.playground,
  plugin.cleaner,
  plugin.translations,
  plugin.safeArea,
]

export { defaultPlugins, plugin }
